import { RESET_REDUX_STATE, SET_PREVIOUS_PATH } from "../constants";

const initialValue = {
  previous_path: null,
};

const path = (state = initialValue, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_PREVIOUS_PATH: {
      return {
        ...state,
        previous_path: payload,
      };
    }

    case RESET_REDUX_STATE: {
      return {
        initialValue,
      };
    }

    default: {
      return state;
    }
  }
};

export default path
